import "./Shimmer.css";

const Shimmer = ({ type = "section", count = 1 }) => {
  return (
    <div className={`shimmer_wrapper shimmer_${type}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div className="shimmer_item" key={index}>
          {type === "card" && (
            <>
              <div className="shimmer_image"></div>
              <div className="shimmer_content">
                <div className="shimmer_line shimmer_title"></div>
                <div className="shimmer_line"></div>
                <div className="shimmer_line shimmer_short"></div>
              </div>
            </>
          )}

          {type === "product" && (
            <>
              <div className="shimmer_product_image"></div>
              <div className="shimmer_line shimmer_title"></div>
              <div className="shimmer_line shimmer_short"></div>
            </>
          )}

          {type === "banner" && <div className="shimmer_banner"></div>}

          {type === "text" && (
            <>
              <div className="shimmer_line shimmer_title"></div>
              <div className="shimmer_line"></div>
              <div className="shimmer_line"></div>
              <div className="shimmer_line shimmer_short"></div>
            </>
          )}

          {type === "section" && (
            <>
              <div className="shimmer_line shimmer_heading"></div>
              <div className="shimmer_line"></div>
              <div className="shimmer_line shimmer_short"></div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default Shimmer;
